import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../../common/integrations'
import { useCallback, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { MappingType } from '../../../../../../../models/Account'
import { useGetIntegrationAdminSettings } from '../../../hook'
import { SelectTaskTypeSection } from './SelectTaskTypeSection'
import { CustomTaskAdminSettings } from './CustomTaskAdminSettings'
import { IntegrationMappingTesterAccordion } from '../../../../TesterTool/TesterAccordion'
import { TaskMappingTester } from '../../../../TesterTool/Task/TaskMappingTester'

export interface TaskAdminSettingsProps {
  serviceId: IntegrationServiceId
}

export const TaskAdminSettings: React.FC<TaskAdminSettingsProps> = ({ serviceId }) => {
  const [formKey, setFormKey] = useState<number>(0)
  const { watch } = useFormContext<IntegrationSettings>()
  const currentMappingType = watch('mappings.task.mappingType')

  const isCustom = useMemo(() => currentMappingType === MappingType.CUSTOM, [currentMappingType])

  const refreshForm = useCallback(() => {
    setFormKey((prevKey) => prevKey + 1)
  }, [])

  const { isAccountFetching } = useGetIntegrationAdminSettings(serviceId)

  if (isAccountFetching) {
    return (
      <Container>
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
        <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }} />
      </Container>
    )
  }

  return (
    <Container className='py-3'>
      <Row className='mb-3'>
        <Col>
          <h3 className='mb-2'>Tasks</h3>
          <div className='zocks-text-gray-600'>Configure where Zocks saves ‘Tasks’ in {getIntegrationDisplayName(serviceId)}.</div>
        </Col>
      </Row>
      <Row>
        <SelectTaskTypeSection onChange={refreshForm} serviceId={serviceId} />
      </Row>
      {isCustom ? (
        <>
          <Row>
            <CustomTaskAdminSettings serviceId={serviceId} formKey={formKey} />
          </Row>
          <Row className='mt-5'>
            <IntegrationMappingTesterAccordion serviceId={serviceId} testerComponents={[TaskMappingTester]} title='Test Task Export' />
          </Row>
        </>
      ) : null}
    </Container>
  )
}
